import { DefaultError, useMutation } from "@tanstack/react-query";
import { useQueryToast } from "hooks";
import i18next from "i18next";
import { apiClient } from "utils";
import { useResponseHandler } from "utils/service/responseHandler";
import { IRegisterForm } from "./types";

export const useRegister = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast("useRegister");
  return useMutation<any, DefaultError, IRegisterForm>({
    async mutationFn(body) {
      loading(i18next.t("service-message.auth.request-reset-password.loading"));

      const response = await apiClient({
        method: "POST",
        url: "Auth/Register",
        body,
      });

      return responseHandler(response, {
        groupName: "useRegister",
      });
    },
    onError: dismiss,
    onSuccess(data) {
      success(i18next.t("service-message.auth.register.success"));
    },
  });
};
